'use es6';

import omit from 'transmute/omit';
const getObjectWithOmittedProps = (source, propOmissionMap = {}) => {
  const unwantedProps = Object.keys(source).filter(prop => source[prop] === undefined || source[prop] === propOmissionMap[prop]);
  return omit(unwantedProps, source);
};
export default getObjectWithOmittedProps;